import styled from 'styled-components';

const CheckboxesCellPdf = styled.div`
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  row-gap: 4pt;
  column-gap: 8pt;
  align-items: center;
`;
export default CheckboxesCellPdf;
